import { type AnalyticsBrowser } from '@segment/analytics-next';

/**
 *  initialize engagement according to the documentation
 *  https://amplitude.com/docs/guides-and-surveys/sdk
 */
export const initAmplitudeEngagement = async ({
  amplitudeApiKey,
  segmentInstance,
  engagementOptions,
}: {
  amplitudeApiKey: string;
  segmentInstance: AnalyticsBrowser;
  engagementOptions: {
    serverZone: 'EU' | 'US';
    locale: 'fr' | 'en' | 'de' | 'es';
  };
}) => {
  const engagement = await import('@amplitude/engagement-browser');

  engagement.init(amplitudeApiKey, engagementOptions);
  const user = await segmentInstance.user();
  await window.engagement?.boot({
    user: {
      // eslint-disable-next-line camelcase
      user_id: user.id() ?? undefined,
      // eslint-disable-next-line camelcase
      device_id: user.anonymousId() ?? undefined,
    },
    integrations: [
      {
        track: ({
          // eslint-disable-next-line camelcase, @typescript-eslint/naming-convention
          event_type,
          // eslint-disable-next-line camelcase, @typescript-eslint/naming-convention
          event_properties,
        }: {
          event_type: string;
          event_properties: Record<string, unknown>;
        }) => {
          segmentInstance.track(event_type, event_properties);
        },
      },
    ],
  });

  segmentInstance.on('track', (event, properties) => {
    window.engagement?.forwardEvent({
      // eslint-disable-next-line camelcase
      event_type: event,
      // eslint-disable-next-line camelcase
      event_properties: properties,
    });
  });
};